<template>
    <div>
        <div class="row">
            <div class="col-12 d-flex justify-content-between align-items-baseline">
                <p class="text-muted mb-0"><strong>Sub locations</strong></p>
                <button @click="newSubLocation"
                        :disabled="loading"
                        class="btn btn-sm btn-secondary">
                    New sub location
                </button>
            </div>
        </div>
        <VueGoodTable :columns="columns"
                      :rows="subLocations"
                      @on-row-click="viewSubLocation"
                      :pagination-options="{
                        setCurrentPage: query.page,
                        perPage: query.limit,
                        enabled: true,
                      }"
                      :sort-options="{
                        initialSortBy: query.sort,
                      }"
                      :isLoading.sync="loading"
                      :totalRows="total"
                      styleClass="vgt-table condensed"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { VueGoodTable } from 'vue-good-table';
import { dotNotationToNested, getUsingDotNotation } from '../../utils/helpers';

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    ...mapGetters({
      subLocations: 'subLocations/subLocations',
      location: 'locations/location',
    }),
    ...mapState({
      query: (state) => state.subLocations.query,
      total: (state) => state.subLocations.totalSubLocations,
    }),
  },
  data() {
    return {
      loading: false,
      columns: [],
    };
  },
  mounted() {
    this.columns = [
      {
        label: 'Name',
        field: 'location',
        filterOptions: {
          filterValue: getUsingDotNotation(this.query.filters, 'location'),
          enabled: false,
        },
      },
    ];
    this.getSubLocations();
  },
  methods: {
    newSubLocation() {
      this.$store.dispatch('subLocations/newSubLocation', this.location.id);
    },
    getSubLocations() {
      this.loading = true;

      this.$store.dispatch('subLocations/getSubLocations')
        .finally(() => {
          this.loading = false;
        });
    },
    viewSubLocation(event) {
      this.$store.dispatch('subLocations/openSubLocationModal', {
        id: event.row.id,
        isNewSubLocation: false,
      });
    },
    updateParams(props) {
      this.$store.commit('subLocations/queryProps', props);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getSubLocations();
    },

    onPerPageChange(params) {
      this.updateParams({
        limit: params.currentPerPage,
        page: 1,
      });
    },

    onSortChange(params) {
      if (JSON.stringify(params) === JSON.stringify(this.query.sort)) {
        // Hackfix. For some reason vue-good-table triggers this twice when initialSortBy is set
        return;
      }
      this.updateParams({
        sort: params,
        page: 1,
      });
    },

    onColumnFilter(params) {
      const filters = dotNotationToNested(params.columnFilters);
      if (JSON.stringify(filters) === JSON.stringify(this.query.filters)) {
        // Hackfix. For some reason vue-good-table triggers this twice when initialSortBy is set
        return;
      }

      this.updateParams({
        filters,
        page: 1,
      });
    },
  },
};
</script>
